import * as topicsApi from '@lumapps/sa-topics/api';

const fetchTopics = async (programId) => {
    const response = await topicsApi.fetch({ programId });

    return response.data.items;
};

export { fetchTopics };
